module.exports = Em.View.extend({})
